import { DOMHelper } from 'core/DOMHelper';
import { DepartmentType } from 'app/data/Enums';
import { Point } from 'app/contracts/Geometry';
import { TextScramble } from 'utils/TextScramble';
import { HomeViewCallbacks } from './home.types';

/**
 * DOM side of the home section: AJAX HTML storage/injection, the intro
 * action TextScramble and the explore-button hover wiring.
 *
 * NOTE: the intro press flow itself (show/opening-action methods) stays in
 * HomeController — it is Events-bus registration and cross-controller
 * orchestration heavy, which the template pins to the controller.
 */
export class HomeView {
	private _dom: DOMHelper;
	private _callbacks: HomeViewCallbacks;

	//AJAX Loaded HTML:
	private _html: string;
	private _htmlLoading: boolean = false;

	private _textScrable: TextScramble;

	constructor(dom: DOMHelper, callbacks: HomeViewCallbacks) {
		this._dom = dom;
		this._callbacks = callbacks;
	}

	//HTML injection
	//-------------------------------------------------------------------------------------

	public get htmlLoading(): boolean {
		return this._htmlLoading;
	}

	/** Store the AJAX loaded HTML for the section */
	public storeHTML(html: string): void {
		this._html = html;
	}

	/** Append the loaded HTML to the body and hand the container back up */
	public injectHTML(onInjected: Function = null): void {
		this._htmlLoading = true;

		this._dom.append(document.querySelector('body'), this._html, () => {
			this._htmlLoading = false;
			this._callbacks.onContainerReady(document.querySelector('.home'));
			if (onInjected) {
				onInjected();
			}
		});
	}

	//Intro action text scramble
	//-------------------------------------------------------------------------------------

	public get textScramble(): TextScramble {
		return this._textScrable;
	}

	public createTextScramble(): void {
		this._textScrable = new TextScramble(document.querySelector('.home__action__text'), 10);
	}

	//Explore button hover wiring
	//-------------------------------------------------------------------------------------

	public bindExploreButton(): void {
		let button = document.querySelector('.home__explore__area .home__action__button__wrapper');

		if (button) {
			button.addEventListener('mouseover', (e) => {
				let rect = (e.target as HTMLElement).parentElement.parentElement.getBoundingClientRect();
				let center: Point = { x: rect.left + 50, y: rect.top + 80 };
				this._callbacks.onExploreHover(center);
			});

			button.addEventListener('mouseout', () => {
				this._callbacks.onExploreOut(DepartmentType.SCREENS);
			});

			button.addEventListener('mouseover', (e) => {
				let rect = (e.target as HTMLElement).parentElement.parentElement.getBoundingClientRect();
				let center: Point = { x: rect.left + 50, y: rect.top + 80 };
				this._callbacks.onExploreHover(center);
			});

			button.addEventListener('mouseout', () => {
				this._callbacks.onExploreOut(DepartmentType.SPACES);
			});
		}
	}
}
